var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.207,
    height: 18.207,
    viewBox: "0 0 18.207 18.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_buildings-2",
    "data-name": "vuesax/bold/buildings-2",
    transform: "translate(-492 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "buildings-2",
    transform: "translate(492 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H18.207V18.207H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M6.524,1.631a.269.269,0,0,1-.266.266H5.4A2.979,2.979,0,0,0,2.428,4.87v7a.269.269,0,0,1-.266.266H1.631A1.628,1.628,0,0,1,0,10.507V1.631A1.628,1.628,0,0,1,1.631,0H4.893A1.628,1.628,0,0,1,6.524,1.631Z",
    transform: "translate(1.517 1.517)",
    fill: "#1383d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M6.524,1.631v8.876a1.628,1.628,0,0,1-1.631,1.631H4.415a.269.269,0,0,1-.266-.266v-7A2.979,2.979,0,0,0,1.176,1.9H.266A.269.269,0,0,1,0,1.631,1.628,1.628,0,0,1,1.631,0H4.893A1.628,1.628,0,0,1,6.524,1.631Z",
    transform: "translate(10.165 1.517)",
    fill: "#1383d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M6.258,0H1.836A1.832,1.832,0,0,0,0,1.836V10.3a1.832,1.832,0,0,0,1.836,1.836H3.072a.376.376,0,0,0,.379-.379v-1.9a.569.569,0,0,1,1.138,0v1.9a.376.376,0,0,0,.379.379h1.3a1.829,1.829,0,0,0,1.828-1.828V1.836A1.832,1.832,0,0,0,6.258,0ZM5.538,6.638H2.5A.569.569,0,0,1,2.5,5.5H5.538a.569.569,0,0,1,0,1.138Zm0-2.276H2.5a.569.569,0,0,1,0-1.138H5.538a.569.569,0,0,1,0,1.138Z",
    transform: "translate(5.083 4.552)",
    fill: "#1383d9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildings);
export default __webpack_public_path__ + "static/media/buildings.4a23f99b1b662cd24c38cad32e791334.svg";
export { ForwardRef as ReactComponent };